import React from 'react';
import { Button, Col, Form, Input, notification, Row, Select, Space, Typography } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { CloseOutlined, ContainerOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AppSelect } from '../../../../constants/appSelect';
import { createPartnerRequest } from '../../../../services/onlinestore/partnerServiceRequest';

const { Text, Title } = Typography;

const CreatePartner = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // handle submit form
  const { mutate: mutateCreatePartner, isPending } = useMutation({
    mutationFn: createPartnerRequest,
    onSuccess: async (data) => {
      if (data?.status === 1) {
        notification.success({
          message: 'Thêm mới đối tác thành công!',
        });
        navigate(-1);
      } else {
        notification.error({
          message: data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    mutateCreatePartner(data);
  };

  return (
    <Form
      name="create-partner"
      form={form}
      layout="vertical"
      className="mb-5"
      onFinish={handleSubmitForm}
    >
      <Row gutter={[16, 0]}>
        <Col xs={24}>
          <Title level={3}>Thêm đối tác</Title>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="title"
            label={
              <Text>
                Tên đối tác <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng nhập tên đối tác' }]}
          >
            <Input placeholder="Nhập tên đối tác..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="description"
            label={
              <Text>
                Mô tả <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng nhập mô tả' }]}
          >
            <Input placeholder="Nhập mô tả..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="phone"
            label={<Text>Số điện thoại</Text>}
            rules={[
              {
                validator: (_, value) =>
                  !value || /^\d{10}$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error('Số điện thoại không đúng định dạng')),
              },
            ]}
          >
            <Input type="number" placeholder="Nhập số điện thoại..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="email"
            label={<Text>Email</Text>}
            rules={[
              {
                type: 'email',
                message: 'Email không đúng định dạng',
              },
            ]}
          >
            <Input placeholder="Nhập email..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item name="address" label={<Text>Địa chỉ</Text>}>
            <Input placeholder="Nhập địa chỉ..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="status"
            label={
              <Text>
                Trạng thái <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
          >
            <Select
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              placeholder="Chọn trạng thái"
              options={AppSelect.PARTNER_STATUS}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <Space>
                <Button htmlType="button" icon={<CloseOutlined />} onClick={() => navigate(-1)}>
                  Hủy bỏ
                </Button>
                <Button loading={isPending} htmlType="submit" type="primary" icon={<ContainerOutlined />}>
                  Lưu lại
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default CreatePartner;
